export const DateKeys = {
    DELETED_AT: 'deletedAt',
    CREATED_AT: 'createdAt',
    START_DATE: 'startDate',
    END_DATE: 'endDate',
    DOB: 'dob',
    DELIVERY_DATE: 'deliveryDate',
    UPDATED_AT: 'updatedAt',
};
